import { Text } from '@chakra-ui/react';

export const NotPublishedMessage: React.FC = () => {
  return <Text>This event has not been published</Text>;
};
